import React, { createElement, useEffect, useState } from 'react';
import { Form, Col } from 'antd';
import { default as DatePicker } from '../datePicker';
import { generateRules } from '../../../utils/index';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
var PickerFomat;
(function (PickerFomat) {
    PickerFomat["date"] = "YYYY-MM-DD";
    PickerFomat["month"] = "YYYY-MM";
    PickerFomat["year"] = "YYYY";
})(PickerFomat || (PickerFomat = {}));
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormDatePicker = (props, ref) => {
    const { isNecessary, verifytext, type, title, __id, rules, status, span, column, ...other } = props;
    const [rule, setRule] = useState([]);
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    useEffect(() => {
        setError(false);
        try {
            setRule(generateRules(rules));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    const format = (e) => {
        if (e)
            return e.format(PickerFomat[type]);
        return null;
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '日期', name: __id || props.componentId, getValueFromEvent: format, rules: rule },
                createElement(DatePicker, Object.assign({ style: { width: '100%' }, disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, { format: PickerFomat[type], picker: type }))))))));
};
export default React.forwardRef(FormDatePicker);
